var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "asta-tavolo" },
    [
      _c(
        "div",
        { staticClass: "area-logs" },
        [
          _vm.astaLogsLast
            ? _c("asta-log", {
                attrs: { small: "", hasEffect: "", log: _vm.astaLogsLast },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              staticClass: "btn-logs text-none",
              attrs: { "x-small": "", depressed: "", rounded: "" },
              on: { click: _vm.showAstaLogs },
            },
            [_c("v-icon", [_vm._v("more_horiz")])],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.tavoloLayout == _vm.Constants.TAVOLO_LAYOUT.CERCHIO
        ? _c("asta-tavolo-cerchio")
        : _c("asta-tavolo-griglia"),
      _vm._v(" "),
      _vm.listoneStatus != 1 && !_vm.listoneStatusClosed
        ? _c("div", { staticClass: "listoneStatus-wrapper" }, [
            _c(
              "div",
              { class: _vm.listoneStatusClass },
              [
                _c(
                  "v-btn",
                  {
                    staticClass: "listoneStatus-close",
                    attrs: { depressed: "", small: "", icon: "" },
                    on: {
                      click: function ($event) {
                        return _vm.closelistoneStatus()
                      },
                    },
                  },
                  [_c("v-icon", { attrs: { small: "" } }, [_vm._v("close")])],
                  1
                ),
                _vm._v("\n      " + _vm._s(_vm.listoneStatusMsg) + "\n    "),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "top-left-corner" }),
      _vm._v(" "),
      _c("div", { staticClass: "top-right-corner" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }